import React, { useState } from "react";
import ModalCst from "@components/ModalCst";
import { ModalDownloadUploadCstInterface } from "./types";
import { useTranslation } from "react-i18next";
import DownloadUploadModalCst from "./components/DownloadUploadCst";

const ModalDownloadUploadCst: React.FC<ModalDownloadUploadCstInterface> = ({
  open,
  setOpen,
  title,
  data,
  onCompleteDisclaimer,
  infoMessage,
}) => {
  const { t } = useTranslation(["modal"]);
  const [isDownloading, setIsDownloading] = useState(false);
  return (
    <ModalCst
      open={open}
      setOpen={setOpen}
      disableBackdropClick={isDownloading}
    >
      <DownloadUploadModalCst
        title={`${t("upload")} ${(title || "").toLowerCase()}`}
        data={data}
        onCancelAction={() => setOpen(false)}
        onCompleteDisclaimer={onCompleteDisclaimer}
        infoMessage={infoMessage}
        onDownloadingChange={setIsDownloading}
      />
    </ModalCst>
  );
};

export default ModalDownloadUploadCst;
